import { View, Text, YStack, XStack, useTheme } from 'tamagui'
import { ReactNode, useMemo } from 'react'
import { Badge } from '@components/Badge'
import RenderHtml from 'react-native-render-html'
import { Dimensions } from 'react-native'
import { HeroIcon } from '@components/HeroIcon'

interface IQuestionCardProps {
  questionNumber: number
  title: string
  value: number
  children: ReactNode
  statement?: string
}

export function QuestionCard({
  questionNumber,
  title,
  value,
  children,
  statement,
}: IQuestionCardProps) {
  const theme = useTheme()

  const textColor = useMemo(() => {
    try {
      return theme['$neutral-800']?.get() || theme.$color?.get() || '#262626'
    } catch {
      return '#262626'
    }
  }, [theme])

  return (
    <YStack>
      <View
        flexDirection="column"
        alignItems="flex-start"
        gap="$spacing-inset-sm"
        mb="$spacing-inset-sm"
      >
        <XStack gap="$spacing-inset-nano" alignItems="flex-start">
          <Text
            fontFamily="$mulishRegular"
            fontSize="$font-size-sm"
            color="$neutral-800"
            lineHeight={25}
            fontWeight={700}
          >
            {questionNumber}.
          </Text>
          <RenderHtml
            contentWidth={Dimensions.get('window').width - 40}
            source={{ html: title }}
            tagsStyles={{
              p: {
                marginTop: 0,
              },
            }}
            baseStyle={{
              color: textColor,
              fontSize: 20,
              fontFamily: 'Mulish-Regular',
              lineHeight: 25,
            }}
          />
        </XStack>

        <View flexDirection="row" alignItems="center" gap="$spacing-inset-nano">
          <Text
            fontSize="$font-size-xs"
            color="$neutral-800"
            fontFamily="$mulishRegular"
          >
            Vale:
          </Text>
          <Badge text={`${value} pontos`} variant="info" />
        </View>
      </View>

      {children}

      {statement && (
        <View
          backgroundColor="$neutral-100"
          borderRadius="$border-radius-sm"
          p="$spacing-inset-xs"
          mb="$spacing-inset-xs"
          mt="$spacing-inset-sm"
        >
          <XStack
            gap="$spacing-inset-quarck"
            alignItems="center"
            mb="$spacing-inset-nano"
          >
            <HeroIcon
              icon={['fal', 'lightbulb']}
              size={20}
              color="$primary-300"
            />
            <Text
              color="$primary-300"
              fontSize="$font-size-xs"
              fontFamily="$mulishBold"
              fontWeight={700}
            >
              Comentário da questão
            </Text>
          </XStack>
          <RenderHtml
            tagsStyles={{
              p: {
                margin: 0,
                padding: 0,
              },
            }}
            contentWidth={Dimensions.get('window').width - 40}
            source={{ html: statement }}
            baseStyle={{
              color: textColor,
              fontSize: 14,
              fontFamily: 'Mulish-Regular',
              lineHeight: 21,
            }}
          />
        </View>
      )}
    </YStack>
  )
}
